import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-15e8850d"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "uploader"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "28",
    height: "28",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/_createElementVNode("path", {
    fill: "#8c939d",
    d: "M480 480V128a32 32 0 0164 0v352h352a32 32 0 110 64H544v352a32 32 0 11-64 0V544H128a32 32 0 010-64h352z"
  })], -1);
});

var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = {
  class: "card thumbnail-card"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "",
    alt: "缩略图",
    id: "thumbnail"
  }, null, -1);
});

var _hoisted_6 = {
  class: "success-label"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "success-icon"
  }, [/*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "12",
    height: "12",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/_createElementVNode("path", {
    fill: "white",
    d: "M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z"
  })])], -1);
});

var _hoisted_8 = [_hoisted_7];
var _hoisted_9 = {
  class: "thumbnail-actions"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "20",
    height: "20",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/_createElementVNode("path", {
    fill: "white",
    d: "M795.904 750.72l124.992 124.928a32 32 0 01-45.248 45.248L750.656 795.904a416 416 0 1145.248-45.248zM480 832a352 352 0 100-704 352 352 0 000 704zm-32-384v-96a32 32 0 0164 0v96h96a32 32 0 010 64h-96v96a32 32 0 01-64 0v-96h-96a32 32 0 010-64h96z"
  })], -1);
});

var _hoisted_11 = [_hoisted_10];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "20",
    height: "20",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/_createElementVNode("path", {
    fill: "white",
    d: "M160 256H96a32 32 0 010-64h256V95.936a32 32 0 0132-32h256a32 32 0 0132 32V192h256a32 32 0 110 64h-64v672a32 32 0 01-32 32H192a32 32 0 01-32-32V256zm448-64v-64H416v64h192zM224 896h576V256H224v640zm192-128a32 32 0 01-32-32V416a32 32 0 0164 0v320a32 32 0 01-32 32zm192 0a32 32 0 01-32-32V416a32 32 0 0164 0v320a32 32 0 01-32 32z"
  })], -1);
});

var _hoisted_13 = [_hoisted_12];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_progress = _resolveComponent("el-progress");

  var _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
    type: "file",
    id: "file-input",
    style: {
      "display": "none"
    },
    accept: "image/*",
    onChange: _cache[0] || (_cache[0] = function () {
      return $setup.onImageAdded && $setup.onImageAdded.apply($setup, arguments);
    })
  }, null, 32), !$setup.isThumbnailVisible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "card upload-card",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.openFileDialog && $setup.openFileDialog.apply($setup, arguments);
    })
  }, _hoisted_3)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_4, [_hoisted_5, _withDirectives(_createElementVNode("label", _hoisted_6, _hoisted_8, 512), [[_vShow, $setup.isSuccessLabelVisible]]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", {
    class: "thumbnail-preview",
    onClick: _cache[2] || (_cache[2] = function () {
      return $setup.handleThumbnailPreview && $setup.handleThumbnailPreview.apply($setup, arguments);
    })
  }, _hoisted_11), _createElementVNode("span", {
    class: "thumbnail-delete",
    onClick: _cache[3] || (_cache[3] = function () {
      return $setup.handleThumbnailRemove && $setup.handleThumbnailRemove.apply($setup, arguments);
    })
  }, _hoisted_13)]), _withDirectives(_createVNode(_component_el_progress, {
    type: "circle",
    percentage: $setup.progress,
    width: 110,
    id: "progress"
  }, null, 8, ["percentage"]), [[_vShow, $setup.isProgressVisible]])], 512), [[_vShow, $setup.isThumbnailVisible]]), _createVNode(_component_vue_easy_lightbox, {
    moveDisabled: "",
    visible: $setup.isLightBoxVisible,
    imgs: $setup.localImageUrl,
    index: $setup.index,
    onHide: $setup.handleLightboxHide
  }, null, 8, ["visible", "imgs", "index", "onHide"])]);
}